import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@fantaz/shared/app-config';
import {
  SponsorConfirmation,
  SponsorConfirmationResponse,
} from '@fantaz/shared/data-access/models';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

const SPONSOR_KEY = 'sponsorName';

export class InvalidPromoCodeError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'InvalidPromoCodeError';
  }
}

export class InvalidSponsorError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'InvalidSponsorError';
  }
}

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  constructor(private http: HttpClient) {}

  /**
   * Confirm user sponsor
   *
   * @param {object} data - SponsorConfirmation
   * @returns Observable<SponsorConfirmationResponse | Observable<never>>
   */
  confirmSponsor(
    data: SponsorConfirmation,
  ): Observable<SponsorConfirmationResponse | Observable<never>> {
    const endpoint = `${environment.apiBaseUrl}/core-client/api/user/set-sponsor`;
    return this.http.post<SponsorConfirmationResponse>(endpoint, data).pipe(
      map((data) => {
        if (data.status === 'ERROR') {
          // verify if the error is a promo code error
          if (
            data.message &&
            [
              'PROMO_CODE_EXPIRED',
              'PROMO_CODE_DISABLED',
              'PROMO_CODE_NOT_FOUND',
            ].includes(data.message)
          ) {
            throw new InvalidPromoCodeError(data.message as string);
          }
          if (data.message && data.message === 'Incorrect request type') {
            throw new InvalidSponsorError(data.message as string);
          }
        }
        return data;
      }),
      catchError((error) => {
        console.error(error);
        if (
          error &&
          error.error &&
          error.error.message &&
          error.error.message === 'Incorrect request type'
        ) {
          throw new InvalidSponsorError(error.error.message as string);
        }
        return throwError(() => error);
      }),
    );
  }

  /**
   * Load sponsor name from local storage if exist or return null if not
   *
   * @returns string | null
   */
  loadSponsorNameFromLocalStorage(): string | null {
    return localStorage.getItem(SPONSOR_KEY);
  }

  /**
   * Remove sponsor name from local storage
   */
  removeSponsorNameFromLocalStorage(): void {
    localStorage.removeItem(SPONSOR_KEY);
  }
}
